import { useEffect, useState } from 'react'
import { useReactiveVar, useSubscription } from '@apollo/client'

import { NOTIFICATIONS_SUBSCRIPTION } from 'modulesCommon/graphql/subscriptions'
import { currentUserVar, newNotificationVar } from 'modulesCommon/store'

import { setDelayForSubsSkip } from 'shared/utils/setDelayForSubsSkip'

const SubscribeToUser = () => {
  const currentUser = useReactiveVar(currentUserVar)

  const [delaySub, setDelaySub] = useState(true)

  useEffect(() => {
    setDelayForSubsSkip(setDelaySub)
  }, [])

  const { data } = useSubscription(NOTIFICATIONS_SUBSCRIPTION, {
    variables: { user_id: currentUser?.id },
    skip: delaySub
  })

  useEffect(() => {
    if (data) newNotificationVar(data.notificationsSubscription)
  }, [data])

  return null
}

export default SubscribeToUser
